import { Helmet } from "react-helmet-async";
import { brandConfig } from "../config/brandConfig";
import { Product } from "data/products";
import { productsCategoryData } from "../data/category";

type CategorySEOProps = {
  products: Product[];
};

export default function CategorySEO({ products }: CategorySEOProps) {
  const { NDD, brandName } = brandConfig;
  const { canonicalPath, categoryName, description } = productsCategoryData;
  const categorySchema = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "@id": `${NDD}${canonicalPath}#collection`,
      name: categoryName,
      description: description,
      url: `${NDD}${canonicalPath}`,
      isPartOf: {
        "@type": "WebSite",
        name: brandName,
        url: NDD,
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "@id": `${NDD}${canonicalPath}#items`,
      isPartOf: { "@id": `${NDD}${canonicalPath}#collection` },
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      numberOfItems: products.length,
      itemListElement: products.map((product, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: product.name,
        "@id": `${NDD}/produits/${product.slug}#product`,
      })),
    },
  ];

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(categorySchema)}
      </script>
    </Helmet>
  );
}
